<template>
  <FinanceFilter
  :settings="settings"
  :filters="this.$store.getters.filtersFinance"
  :full="false"
  @changeFilters="changeFilters"
  @saveView="saveView"
  @editView="editView"
  @deleteView="deleteView"
  @exportCSV="exportCSV"
  @exportXLSX="exportXLSX"
  @exportFODonations="exportFODonations"
  @exportPODonations="exportPODonations"
  @showAdvanced="showColumnSelect"
  @reloadData="loadData"
  />
  <transition name="fade">
    <template v-if="showingColumnSelect">
      <ColumnFilter
      :settings="settings"
      :selectedColumns="selectedColumns"
      @changeColumns="changeColumns"
      class="px-3"
      />
    </template>
  </transition>
  <Table
  :settings="settings"
  :items="items"
  :columns="selectedColumns"
  @loadData="loadData"
  @changeSort="changeSort"
  @selectAll="selectAll"
  @deselectAll="deselectAll"
  @selectChangeRow="selectChangeRow"
  />
  <Pagination
  :totalCount="settings.totalCount"
  :perPage="settings.perPage"
  :currentPage="settings.currentPage"
  @page-changed="updatePageData"
  @update:per-page="updatePerPage"
  />
  <LoadingSpinner :csvLoading="csvLoading"/>
</template>

<script>
import Table from "@/components/Table.vue";
import ColumnFilter from '@/components/ColumnFilter.vue';
import FinanceFilter from "@/components/FinanceFilter.vue";
import Pagination from "@/components/Pagination.vue";
import ButtonFinances from '@/components/ButtonFinances.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import axios from "axios";
import { markRaw } from "vue";

export default {
  components: {
    Table,
    FinanceFilter,
    ButtonFinances,
    ColumnFilter,
    Pagination,
    LoadingSpinner,
  },
  created: function () {
    this.setDefaultColumns();
    this.settings.perPage = this.$store.getters.filtersFinance.per_page;
    this.settings.sortBy = this.$store.getters.filtersFinance.sort_by;
    this.settings.sortDirection = this.$store.getters.filtersFinance.sort_order;
    this.loadData(this.$store.getters.filtersFinance.current_page);
  },
  data() {
    return {
      listRequestSource: null,
      showingColumnSelect: false,
      csvLoading: false,
      items: [],
      selectedColumns: [],
      settings: {
        endpoint: "/finance/finances/budgets",
        sortBy: "created_at",
        sortDirection: "D",
        settingsType: "finances",
        loading: false,
        totalCount: 0,
        perPage: 50,
        currentPage: 1,
        selected: [],
        columns: [
          {
            col: 2,
            name: "created_at",
            userFriendly: "Datum vložení",
            cellFunction: (item) => { return item.document.created_at },
            sortable: true,
            defaultShow: true
          },
          {
            col: 2,
            name: "apply_at",
            userFriendly: "Datum zaúčtování",
            cellFunction: (item) => { return item.paid_at },
            sortable: true,
            defaultShow: true
          },
          {
            col: 1,
            name: "document_id",
            userFriendly: "Doklad",
            cellFunction: (item) => { return item.document.id },
            sortable: true,
            defaultShow: true
          },
          {
            col: 1,
            name: "amount",
            userFriendly: "Částka",
            cellFunction: (item) => { return item.amount + " Kč" },
            default: "0",
            sortable: true,
            defaultShow: true,
            classFunction: (item) => {
              if (item.document.document_type.financial_type === "V") {
                return "red";
              }
              if (item.document.document_type.financial_type === "P") {
                return "green";
              }
              return ""
            },
          },
          {
            col: 1,
            name: "region",
            userFriendly: "Jednotka",
            cellFunction: (item) => { return item.region.name },
            default: "-",
            sortable: true,
            defaultShow: true
          },
          {
            col: 1,
            name: "vs",
            userFriendly: "VS",
            cellFunction: (item) => { return item.document.vs },
            default: "-",
            sortable: true,
            defaultShow: true
          },
          {
            col: 2,
            name: "description",
            cellFunction: (item) => { return item.document.description },
            userFriendly: "Popis",
            default: "-",
            sortable: true,
            defaultShow: true
          },
          {
            col: 1,
            name: "actions",
            userFriendly: "Akce",
            sortable: false,
            cellComponent: markRaw(ButtonFinances),
            defaultShow: true
          },
        ],
        row: {
          isClickable: this.isClickable,
          name: 'finance-detail'
        }
      }
    }
  },
  methods: {
    isClickable: function (item) {
      return true;
    },
    setDefaultColumns() {
      this.selectedColumns = [];
      if (this.$store.getters.filtersFinance.columns.length > 0) {
        const filteredColumns = this.settings.columns.filter((value) =>{
          return this.$store.getters.filtersFinance.columns.includes(value.name)
        });
        this.selectedColumns = filteredColumns;
      } else {
        for (let i = 0; i < this.settings.columns.length; i++) {
          if (this.settings.columns[i].defaultShow) {
            this.selectedColumns.push(this.settings.columns[i])
          }
        }
      }
    },
    loadData: function (page) {
      // setup
      this.settings.loading = true;

      // cancel last request and create new source
      if (this.listRequestSource !== null) {
        this.listRequestSource.cancel('Operace zrušena uživatelem.');
      }
      this.listRequestSource = axios.CancelToken.source();

      if (page) {
        this.settings.currentPage = page;
      }

      // Send only the data we need on backend
      let filtersCopy = {...this.$store.getters.filtersFinance};
      delete filtersCopy.columns;
      const data = {
        cancelToken: this.listRequestSource.token,
        params: {...filtersCopy}
      };
      this.$store.getters.api.get(this.settings.endpoint, data).then(function (response) {
        const resData = response.data;
        this.items = resData.items;
        this.settings.totalCount = resData._total;

        // cancel loading and remove request source
        this.settings.loading = false;
        this.listRequestSource = null;
      }.bind(this))
      .catch((e) => {
          if (axios.isCancel(e)) {
              console.log("Request canceled", e.message);
          } else {
              console.log(e);
          }
          this.requestRunning = false;
      });
    },
    changeFilters: function (key, val) {
      this.$store.commit("setFiltersFinance", { key, value: val });
      this.$store.commit("setFiltersFinance", { key: "current_page", value: 1 });
      this.settings.currentPage = 1;
      if (key === "per_page") {
        this.settings.perPage = val;
      }
      if (key === "sort_by") {
        this.settings.sortBy = val;
      }
      if (key === "sort_order") {
        this.settings.sortDirection = val;
      }
      if (key === "columns") {
        if (val.length > 0) {
          const filteredColumns = this.settings.columns.filter((value) =>{
            return val.includes(value.name)
          });
          this.selectedColumns = filteredColumns;
        } else {
          this.setDefaultColumns();
        }
      }
    },
    changeColumns: function (columns) {
      const selectedColNames = [];
      columns.forEach((column) => {
        selectedColNames.push(column.name);
      });
      this.$store.commit("setFiltersFinance", { key: "columns", value: selectedColNames });
      this.selectedColumns = columns;
    },
    changeSort: function (column, direction) {
      this.$store.commit("setFiltersFinance", { key: "sort_by", value: column });
      this.settings.sortBy = column;
      this.$store.commit("setFiltersFinance", { key: "sort_order", value: direction });
      this.settings.sortDirection = direction;
      this.$store.commit("setFiltersFinance", { key: "current_page", value: 1 });
      this.settings.currentPage = 1;
      this.loadData();
    },
    selectChangeRow: function (item_id, state) {
      if (state) {
        this.settings.selected.push(item_id)
      }
      else {
        const index = this.settings.selected.indexOf(item_id);
        this.settings.selected.splice(index, 1);
      }
    },
    selectAll: function () {
      this.deselectAll();
      for (let i = 0; i < this.items.length; i++) {
        this.settings.selected.push(this.items[i].id)
      }
    },
    deselectAll: function () {
      this.settings.selected = [];
    },
    updatePageData(page) {
      this.$store.commit("setFiltersFinance", { key: "current_page", value: page });
      this.settings.currentPage = page;
      this.loadData();
    },
    updatePerPage(newPerPage) {
      this.$store.commit("setFiltersFinance", { key: "per_page", value: newPerPage });
      this.settings.perPage = newPerPage;
      this.$store.commit("setFiltersFinance", { key: "current_page", value: 1 });
      this.settings.currentPage = 1;
      this.loadData();
    },
    saveView: function (name) {
      const userId = this.$store.getters.user.user.id;
      const view = this.buildViewData();
      view.name = name;
      this.$store.getters.api.post("/user/" + userId + "/settings", view).then(function (response) {
        // reload store settings data?
      }.bind(this));
    },
    editView: function (id) {
      const userId = this.$store.getters.user.user.id;
      const view = this.buildViewData();
      const oldView = this.$store.getters.settings.find((view) => view.id == id);
      view.id = id;
      view.name = oldView.name;
      this.$store.getters.api.put("/user/" + userId + "/settings", view).then(function (response) {
        // reload store settings data?
      }.bind(this));
    },
    deleteView: function (id) {
      const userId = this.$store.getters.user.user.id;
      this.$store.getters.api.delete("/user/" + userId + "/settings/" + id).then(function (response) {
        // reload store settings data?
      }.bind(this));
    },
    buildViewData: function () {
      const selectedColNames = [];
      this.selectedColumns.forEach((column) => {
        selectedColNames.push(column.name);
      });
      this.$store.commit("setFiltersFinance", { key: 'columns', value: selectedColNames });
      this.$store.commit("setFiltersFinance", { key: 'per_page', value: this.settings.perPage });
      this.$store.commit("setFiltersFinance", { key: 'sort_by', value: this.settings.sortBy });
      this.$store.commit("setFiltersFinance", { key: 'sort_order', value: this.settings.sortDirection });
      const view = {
        id: null,
        name: null,
        settings_type: this.settings.settingsType,
        group: null,
        data: this.$store.getters.filtersFinance
      };
      return view;
    },
    showColumnSelect: function () {
      this.showingColumnSelect = !this.showingColumnSelect;
    },
  },
}
</script>

<style scoped lang="scss">
</style>
